import type { AuditRunStatus } from '../api/enrollment-overlap.types'
import { isClientError } from './api-errors'
import { POLL_INTERVAL_MS, isRunStalled } from './run-display'

/**
 * How long to wait before re-fetching a run, or `false` to stop polling.
 *
 * Polling continues only while the run is (or may still be) RUNNING. It stops
 * for any terminal status and for 4xx errors (unknown run, no access), which
 * retrying cannot fix. A transient 5xx keeps polling.
 *
 * A RUNNING run older than ~20 minutes is abandoned ("Possibly stalled"), so
 * polling stops for it as well: it will not finish by itself.
 *
 * `status` is `undefined` before the first response; the run was just started
 * or seen as RUNNING, so it is treated as still running.
 */
export function nextPollInterval(
  status: AuditRunStatus | undefined,
  error: unknown,
  startedAt?: string,
  now: number = Date.now()
): number | false {
  if (error && isClientError(error)) return false
  if (
    status === 'RUNNING' &&
    startedAt &&
    isRunStalled({ status, startedAt }, now)
  ) {
    return false
  }
  if (status === undefined || status === 'RUNNING') return POLL_INTERVAL_MS
  return false
}
